import { AppRoute, ConfigSettingsService, MenuStage, NavigationLinkBase } from '@ebeihilfe/core';
import { Injectable } from '@angular/core';

@Injectable()
export class DocumentsNavLink extends NavigationLinkBase {
  public allowedStages = MenuStage.SIGNED_IN;

  constructor(private readonly configService: ConfigSettingsService) {
    super('DOCUMENTS', 'menu.label.finished_antraege', AppRoute.Bescheid, 'a11y.link.bescheid_uebersicht');
  }

  public guard(): boolean {
    return this.configService.appSettings.customizing.hasBescheide;
  }
}
